import * as React from 'react';
// import glamorous from 'glamorous';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import DashboardOutlinedIcon     from '@material-ui/icons/DashboardOutlined';
import ShowChartOutlinedIcon      from '@material-ui/icons/ShowChartOutlined';
import MultilineChartOutlinedIcon from '@material-ui/icons/MultilineChartOutlined';
import BarChartOutlinedIcon       from '@material-ui/icons/BarChartOutlined';
import PieChartOutlinedIcon       from '@material-ui/icons/PieChartOutlined';
import TimelineOutlinedIcon       from '@material-ui/icons/TimelineOutlined';
import ViewListOutlinedIcon       from '@material-ui/icons/ViewListOutlined';
import PlaylistAddCheckOutlinedIcon from '@material-ui/icons/PlaylistAddCheckOutlined';
import FormatListNumberedOutlinedIcon from '@material-ui/icons/FormatListNumberedOutlined';
import PeopleOutlineIcon          from '@material-ui/icons/PeopleOutline';
import PersonOutlineIcon          from '@material-ui/icons/PersonOutline';
import NoteOutlinedIcon           from '@material-ui/icons/NoteOutlined';
import RecordVoiceOverOutlinedIcon from '@material-ui/icons/RecordVoiceOverOutlined';
import EventOutlinedIcon          from '@material-ui/icons/EventOutlined';
import HourglassEmptyOutlinedIcon from '@material-ui/icons/HourglassEmptyOutlined';
import { SvgIcon } from '@material-ui/core';
import RecentActorsOutlinedIcon   from '@material-ui/icons/RecentActorsOutlined';
import MailOutlinedIcon           from '@material-ui/icons/MailOutlined';
import PhoneOutlinedIcon          from '@material-ui/icons/PhoneOutlined';
import DescriptionOutlinedIcon    from '@material-ui/icons/DescriptionOutlined';
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined';
import OpenInNewOutlinedIcon      from '@material-ui/icons/OpenInNewOutlined';
import SettingsOutlinedIcon       from '@material-ui/icons/SettingsOutlined';
import TuneOutlinedIcon           from '@material-ui/icons/TuneOutlined';
import WorkOutlinedIcon           from '@material-ui/icons/WorkOutlined';
import { MatterTerminology } from '../../MatterTerminology';
import { linkToPage } from '../../App';
import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { ApolloError } from 'apollo-client';
import { RvMainDrawer, LinkProps, DockMode } from '../MainDrawer';
import { UserFeature, UserFeatureEnum } from '../../types/UserFeature';
import { WithTranslation, withTranslation } from 'react-i18next';
import { TranslationTextList } from '../../locales/common';

// tslint:disable-next-line:no-any
/* const StyledAppMenu = glamorous.div<{ theme?: any }>((props) => ({
    display: 'flex',
    alignItems: 'center',
    paddingRight: '0 !important',
    [`& .${`button`}`]: {
      color: props.theme.BrandColors.TemplatePrimary,
      backgroundColor: props.theme.NeutralColors.BackgroundWhite,
      fontSize: props.theme.FontSize.EM.size1,
      padding: '12.54px 12.25px 13.67px 13px',
      textAlign: 'center',
      height: '48.19px',
      width: '48px',
      border: '1px solid' + props.theme.NeutralColors.LightBlue1,
      borderRadius: '4px',
      boxShadow: '0 0 4px 0 ' + props.theme.NeutralColors.BackgroundGrey2,
      marginRight: '10px'
    }
  }));
   */
export enum TasksMenu {
    TASKS = 0,
    PHONE_CALLS,
    HIDDEN
}

const initialState = {
    show: false
};
type AppMenuState = Readonly<typeof initialState>;
export interface AppMenuProps extends WithTranslation {
    show: boolean;
}
interface QueryResult {
    loading?: boolean;
    networkStatus?: number;
    error?: ApolloError;
    appUser: AppUser;
}

export interface AppUser {
    isAdministrator: boolean;
    isInternalAdmin: boolean;
    canViewDashboard: boolean;
}

export interface QAppMenuProps extends AppMenuProps {
    id?: string;
    data?: QueryResult;
    handleSidebarHide?: (value: boolean) => void;
    dockMode?: DockMode;
    onCycleDock?: () => void;
}

class AppMenuDrawer extends React.Component<QAppMenuProps, AppMenuState> {
    // readonly state: AppMenuState = initialState;

    constructor(props: AppMenuProps, state: AppMenuState) {
        super(props, state);
        // this.onMenuSelection = this.onMenuSelection.bind(this);
        this.toggleVisibility = this.toggleVisibility.bind(this);
        this.handleSidebarHide = this.handleSidebarHide.bind(this);
        this.toggleTaskAndPhone = this.toggleTaskAndPhone.bind(this);
        this.state = { show: this.props.show };
    }

    UNSAFE_componentWillReceiveProps(
        nextProps: AppMenuProps,
        nextContext: AppMenuState
    ): void {
        this.setState({ show: nextProps.show });
    }

    render() {

        const { t } = this.props as {
            t: (key: keyof TranslationTextList) => string;
        };

        var drawerLinks: Array<LinkProps>;
        const dataReady = this.state.show &&
            this.props.data &&
            this.props.data.appUser &&
            !this.props.data.loading;
        if (dataReady) {
            // tslint:disable-next-line: no-console
            console.log(this.props.data);
            // at the moment only admins can view dashboard
            this.props.data.appUser = {
                canViewDashboard: this.props.data.appUser
                    ? this.props.data.appUser.isAdministrator
                    : false,
                isAdministrator: this.props.data.appUser
                    ? this.props.data.appUser.isAdministrator
                    : false,
                isInternalAdmin: this.props.data.appUser
                    ? this.props.data.appUser.isInternalAdmin
                    : false    
            };
            drawerLinks = [
                // { label: MatterTerminology.Home,
                //     iconKey: 'home',
                //     linkTo: linkToPage('home'),
                //     visible: this.props.data.appUser ? this.props.data.appUser.isAdministrator : false,
                //     // onClick: this.toggleVisibility.bind(this)
                // },
                {
                    label:   MatterTerminology.ClientDashboard,
                    iconKey: <AssignmentIndOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('clientDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasClientDashboard)
                },
                {
                    label:   MatterTerminology.UserDashboard,
                    iconKey: <DashboardOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('userDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasShowUserDashboard)
                },
                {
                    label:   MatterTerminology.FirmDashboard,
                    iconKey: <ShowChartOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('dashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasFirmDashboard)
                },
                {
                    label:   MatterTerminology.FeeEarnerDashboard,
                    iconKey: <MultilineChartOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('feeEarnerDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasShowFeeEarnerDashboard)
                },
                {
                    label:   MatterTerminology.AttorneyDashboard,
                    iconKey: <BarChartOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('lawyerDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasIPAttorneyDashboard)
                },
                {
                    label:   MatterTerminology.MattersSummary,
                    iconKey: <ViewListOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('matterSummary'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasMatterSummary)
                },
                {
                    label:   MatterTerminology.MatterManagement,
                    iconKey: <PlaylistAddCheckOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('matterManagement'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasBulkMatterManagement)
                },
                {
                    label:   MatterTerminology.ClientsAndContacts,
                    iconKey: <PeopleOutlineIcon fontSize="small" />,
                    linkTo:  linkToPage('clientsAndContacts'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasNameSummary)
                },
                {
                    label:   MatterTerminology.ClientContactNotes,
                    iconKey: <NoteOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('notesSummary'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasNotesSummary)
                },
                {
                    label:   MatterTerminology.Referrers,
                    iconKey: <RecordVoiceOverOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('referrers'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasReferrerSummary)
                },
                {
                    label:   MatterTerminology.EventsAndCampaigns,
                    iconKey: <EventOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('eventsAndCampaigns'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasEventsAndCampaignsSummary)
                },
                {
                    label:   MatterTerminology.Staff,
                    iconKey: <PersonOutlineIcon fontSize="small" />,
                    linkTo:  linkToPage('staffSummary'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasStaffSummary)
                },
                {
                    label:   MatterTerminology.Timesheet,
                    iconKey: <HourglassEmptyOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('timesheet'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasTimesheetSummary)
                },
                {
                    label:   t('Marketing Dashboard '),
                    iconKey: <PieChartOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('enquiriesDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasLeadsDashboard)
                },
                {
                    label:   t('Marketing Automation'),
                    iconKey: (
                        <SvgIcon fontSize="small">
                            <path d="M7.5 5.6 10 7 8.6 4.5 10 2 7.5 3.4 5 2l1.4 2.5L5 7zm12 9.8L17 14l1.4 2.5L17 19l2.5-1.4L22 19l-1.4-2.5L22 14zM22 2l-2.5 1.4L17 2l1.4 2.5L17 7l2.5-1.4L22 7l-1.4-2.5zm-7.63 5.29a.9959.9959 0 0 0-1.41 0L1.29 19.59c-.39.39-.39 1.02 0 1.41l2.71 2.71c.39.39 1.02.39 1.41 0L17.7 11.42c.39-.39.39-1.02 0-1.41l-3.33-2.72zm-1.03 5.49-2.12-2.12 2.44-2.44 2.12 2.12-2.44 2.44z" />
                        </SvgIcon>
                    ),
                    linkTo:  linkToPage('marketingAutomation'),
                    visible: (UserFeature.HasAccess(UserFeatureEnum.hasMarketingAutomationRuleSummary) || UserFeature.HasAccess(UserFeatureEnum.hasMarketingAutomationQueueSummary))
                },
                {
                    label:   t('Enquiries'),
                    iconKey: <RecentActorsOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('enquiriesSummary'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasLeadsSummary)
                },
                {
                    label:   MatterTerminology.MailingList,
                    iconKey: <MailOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('mailingList'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasMailingList)
                },
                {
                    label:   MatterTerminology.TaskDashboard,
                    iconKey: <TimelineOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('taskDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasTaskDashboard)
                },
                {
                    label:   this.toggleTaskAndPhone() === TasksMenu.TASKS ? MatterTerminology.Tasks : this.toggleTaskAndPhone() === TasksMenu.PHONE_CALLS ? MatterTerminology.PhoneCalls : MatterTerminology.Tasks,
                    iconKey: this.toggleTaskAndPhone() === TasksMenu.PHONE_CALLS
                        ? <PhoneOutlinedIcon fontSize="small" />
                        : <FormatListNumberedOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('tasksSummary'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasTaskSummary)
                },
                {
                    label:   MatterTerminology.Reports,
                    iconKey: <DescriptionOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('reports'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasLicencedReports)
                },
                {
                    label:   MatterTerminology.Innography,
                    iconKey: <OpenInNewOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('innography'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasInnographyLink)
                },
                {
                    label:   MatterTerminology.ClientSense,
                    iconKey: <OpenInNewOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('clientsense'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasClientSenseLink)
                },
                {
                    label:   MatterTerminology.Admin,
                    iconKey: <SettingsOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('admin'),
                    visible: (UserFeature.HasAccess(UserFeatureEnum.hasAdminDashboardPage) || this.props.data.appUser.isInternalAdmin)
                },
                {
                    label:   MatterTerminology.Configuration,
                    iconKey: <TuneOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('configurationDashboard'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasConfigurationMaintenance),
                    isActiveFn: (pathname: string) => pathname.toLowerCase().includes('configuration'),
                },
                {
                    label:   MatterTerminology.GeneralMaterial,
                    iconKey: <WorkOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('generalMaterial'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasGeneralMaterial)
                },
                {
                    label:   MatterTerminology.ClientDocuments,
                    iconKey: <InsertDriveFileOutlinedIcon fontSize="small" />,
                    linkTo:  linkToPage('clientDocuments'),
                    visible: UserFeature.HasAccess(UserFeatureEnum.hasClientDocuments)
                }
            ];
        } else {
            drawerLinks = new Array<LinkProps>();
        }
        return (
            <RvMainDrawer
                visible={this.state.show}
                links={drawerLinks}
                isLoading={!!(this.props.data && this.props.data.loading)}
                handleSidebarHide={this.handleSidebarHide}
                dockMode={this.props.dockMode}
                onCycleDock={this.props.onCycleDock}
            >
                {this.props.children}
            </RvMainDrawer>
        );
    }

    // private onMenuSelection() {
    //     this.toggleVisibility();
    // }

    private toggleVisibility() {
        this.setState(state => ({ show: !state.show }));
    }

    private handleSidebarHide(value: boolean) {
        if (this.props.dockMode && this.props.dockMode !== 'closed') {
            return;
        }
        this.setState({ show: value });
        if (this.props.handleSidebarHide) {
            this.props.handleSidebarHide(value);
        }
    }
    private toggleTaskAndPhone() {
        if (
            // UserFeature.HasAccess(UserFeatureEnum.hasMatterTasks) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasArchiveMatter) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasBillMatter) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasCloseMatter) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasDeleteTask) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasMatterEmailPersonActing) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasMatterEmailPersonResponsible) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasFollowUpMatterTask) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasWriteOffDebtors) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasWriteOffWIP) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasTransferMatterTrust) ||
            // UserFeature.HasAccess(UserFeatureEnum.hasTaskDetail) ||
            UserFeature.HasAccess(UserFeatureEnum.hasAdHocTask)
        ) {
            return TasksMenu.TASKS;
        } else if (
            UserFeature.HasAccess(UserFeatureEnum.hasPhoneTask)
        ) {
            return TasksMenu.PHONE_CALLS;
        } else {
            return TasksMenu.HIDDEN;
        }
    }
}

const UserData = gql`
  query UserData {
    appUser {
      isAdministrator
      isInternalAdmin
    }
  }
`;

// tslint:disable-next-line:no-any
const AppMenu = graphql<any, AppMenuProps, any>(UserData, {
    // isAdministrator/isInternalAdmin don't change within a session (logout is a hard
    // window.location navigation, not an in-SPA transition, so the cache is always wiped before
    // a different user's data could land here) - cache-first avoids the redundant network
    // refetch cache-and-network (this app's global default) would otherwise force on every
    // mount, matching useCurrentUser.tsx's own default for the same appUser data.
    options: { variables: {}, fetchPolicy: 'cache-first' }
})(AppMenuDrawer);

export default withTranslation()(AppMenu);
